<template>
  <div>
    <v-bottom-navigation
      color="primary"
      grow
      fixed
      height="75px"
      v-if="authorised"
    >
  <!--  <div class="container fixed-bottom">-->
      <v-btn to="/home" v-if="userType === 'merchant'">
        <span>Home</span>
        <v-icon>fas fa-home</v-icon>

      </v-btn>
      <v-btn to="/driver" v-else-if="userType === 'driver'">
        <span>Home</span>
        <v-icon>fas fa-home</v-icon>

      </v-btn>


      <v-btn v-on:click="showBasket" v-if="userType === 'merchant'">
        <span>
        BASKET
        </span>
        <v-badge
          color="green"
          :content="basket"
          :value="basket"
        >
        <v-icon>fas fa-shopping-cart</v-icon>
        </v-badge>
      </v-btn>
      <v-btn @click="movePage('/orders', 'Orders')" v-if="userType === 'merchant' || userType === 'admin'">
        <span>Orders</span>
        <v-icon>fas fa-scroll</v-icon>

      </v-btn>
      <v-btn @click="movePage('/admin/drivers', 'Drivers')" v-if="userType === 'admin'">
        <span>Drivers</span>
        <v-icon>fas fa-truck</v-icon>

      </v-btn>
      <v-btn to="/wms" v-if="canAccessStock() === true">
        <span>Warehouse</span>
        <v-icon>fas fa-warehouse</v-icon>

      </v-btn>
      <v-btn to="/orderstocks" v-if="canAccessPicking() === true">
        <span>Order Stocks</span>
        <v-icon>fas fa-boxes</v-icon>

      </v-btn>
      <v-btn v-if="userType === 'merchant'" v-on:click="showNoticeListView">
        <span>Notice</span>
        <v-icon>fas fa-bell</v-icon>
        <div style="position: absolute; top: 5px; right: 5px; height: 20px; padding-left: 5px; padding-right: 5px; line-height: 20px; font-size: 15px; border-radius: 10px; background: red; font-weight: bold; color:white;">{{getNewNoticeCount()}}</div>
      </v-btn>
      <v-btn @click="movePage('/setting', 'Settings')">
        <span>Account</span>
        <v-icon>fas fa-cog</v-icon>
      </v-btn>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="290"
      >
        <v-card v-if="dialogParams">
          <v-card-title class="headline">{{dialogParams.title}}</v-card-title>
          <v-card-text v-html="dialogParams.text"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  <!--  </div>-->


      <transition name="dissolve">
        <div class="progressView" v-if="isLoading==true">
          <div class="center-container">
            <div class="content-center">
              <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
              <p class="loading-message"> {{loadingMessage}}</p>
            </div>

          </div>
        </div>
      </transition>
    </v-bottom-navigation>
    <transition name="slideup">
      <div v-if="basketView == true" style="z-index:4; position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="basketView = false">
        <div style="position: absolute; width: 90%; height: calc(100% - 100px); top:30px; left: 50%; transform: translateX(-50%); background-color: white; border-radius: 10px;" v-on:click.stop="dummy">
          <div style="height: 40px; line-height: 40px; display: flex;font-size: 25px; ">
            <div style="width: 50px; height: 40px; line-height: 40px; text-align: center;" v-on:click="basketView = false"><span><i class="fas fa-arrow-left"></i></span></div>
            <div style="width: calc(100% - 50px); height: 40px; line-height: 40px; font-size: 25px; padding-left:20px;">BASKET</div>
          </div>
          <div style="height: calc(100% - 40px); width: 100%;">
            <Basket/>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slideup">
      <div v-if="noticeListView == true" style="z-index:4; position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="noticeListView = false">
        <div style="position: absolute; width: 90%; height: calc(100% - 100px); top:30px; left: 50%; transform: translateX(-50%); background-color: white; border-radius: 10px;" v-on:click.stop="dummy">
          <div style="height: 45px; line-height: 50px; display: flex;font-size: 25px; ">
            <div style="width: 50px; height: 50px; line-height: 50px; text-align: center;" v-on:click="noticeListView = false"><span><i class="fas fa-arrow-left"></i></span></div>
            <div style="width: calc(100% - 50px); height: 50px; line-height: 50px; font-size: 25px; padding-left:20px;">Notice</div>
          </div>
          <div style="height: calc(100% - 50px); overflow-y: auto;">
            <ul class="list-group" style="padding-left: 0; width: calc(100% - 10px); margin: auto;" v-if="notices !== null && notices.length > 0">
              <li class="list-group-item" v-for="notice in notices" v-on:click="openNoticeItem(notice)">
                {{notice.title}} <span v-if="notice.readTime === 0" style="font-weight: bold; color: red; padding-left: 20px;">N</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>


    <transition name="slideup">
      <div v-if="noticeItem !== false" style="z-index:4; position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="noticeItem = false">
        <div style="position: absolute; width: 90%; height: calc(100% - 100px); top:30px; left: 50%; transform: translateX(-50%); background-color: white; border-radius: 10px;" v-on:click.stop="dummy">
          <div style="height: 45px; line-height: 50px; display: flex;font-size: 25px; ">
            <div style="width: 50px; height: 50px; line-height: 50px; text-align: center;" v-on:click="noticeItem = false"><span><i class="fas fa-arrow-left"></i></span></div>
            <div style="width: calc(100% - 50px); height: 50px; line-height: 50px; font-size: 25px; padding-left:20px;">Notice</div>
          </div>
          <div style="height: calc(100% - 50px); overflow-y: auto;">
            <div style="width: calc(100% - 20px); margin:auto;">
              <h4>{{noticeItem.title}}</h4>
              <hr/>
              <div style="width: 100%;" v-html="noticeItem.content.replace(/(?:\r\n|\r|\n)/g, '<br>')">

              </div>
              <div style="width: 100%; padding-top: 10px;" v-if="noticeItem.mainContent !== undefined && noticeItem.mainContent !== null && noticeItem.mainContent.length > 0"
                   v-html="noticeItem.mainContent">

              </div>
              <div style="width:100%; text-aligh:center; margin-top:10px;" v-if="noticeItem.imageUrl !== undefined && noticeItem.imageUrl !== null && noticeItem.imageUrl.length > 0">
                <img :src="noticeItem.imageUrl" style="width: 100%;"/>
              </div>
              <hr/>
              <div style="margin-top: 30px;">Date: {{dataString(noticeItem.createdTimestamp)}}</div>
              <div style="margin-top: 20px;" v-if="noticeItem.readTime > 0">Read: {{dataString(noticeItem.readTime)}}</div>

              <button v-if="noticeItem.readTime === 0" class="btn btn-success" style="margin-top: 20px;" @click="markAsRead">Mark as read</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <v-dialog v-if="moveDialog !== null" v-model="moveDialog">
      <v-card>
        <v-card-title class="headline">
          {{moveDialog.text}}
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="onMoveConfirmed(false)">NO</v-btn>
          <v-btn color="green darken-1" text @click="onMoveConfirmed(true)">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="loader-container" v-if="showLoadingAnim === true">
      <div class="lds-circle"><div></div></div>
    </div>
  </div>
</template>

<script>
  import {getBasketOrderCount} from "../api/order";

    require('@/assets/css/loading1.css')
    import Router from '../router';
    import EventBus from '../api/event-bus.js';
  import {getUserByToken} from "../api/user";
  import Basket from "./Basket";
  import {getNotices, setNoticeAsRead} from "../api/notices";
  import {getDateString} from "../api/utils";
    export default {
        name: "TopNav",
      components: {Basket},
      data() {
        return {
          authorised: false,
          isLoading:false,
          loadingMessage:'',

          basket: getBasketOrderCount(),

          dialog: false,
          dialogParams: null,
          userType:'merchant',
          basketView: false,
          noticeListView:false,
          notices: [],
          noticeItem:false,
          noticeCount:0,
          moveDialog: null,
          showLoadingAnim: false,
          user:null,
        }
      },
      created() {
        EventBus.$on('logon', this.onLogged);
        EventBus.$on('showLoading', this.showLoading);
        EventBus.$on('showDialog', this.showDialog);
        EventBus.$on('onBasket', this.onBasket);
        EventBus.$on('setUserType', this.onUserType);
        EventBus.$on('sessionExpired', this.onSessionExpired);
        EventBus.$on('checkNotice', this.checkNotice);

      },
      mounted() {

      },
      methods: {
          dataString:getDateString,
          dummy: function() {

          },
          movePage: function(url, title) {
            if(localStorage.getItem("settingAskConfirmationOnChangePage") !== null && localStorage.getItem("settingAskConfirmationOnChangePage") === 'true') {
              let self = this;
              this.$data.moveDialog = {
                text:'Do you want to move to ' + title  + ' page?',
                destination: url,
              }

              return;
            }
            Router.push(url);
          },
          canAccessPicking: function() {
            return auth.canAccessPicker();
          },
          canAccessStock: function() {
            return auth.canAccessStock();
          },
          onMoveConfirmed: function(proceed) {
            let url = this.$data.moveDialog.destination;
            this.$data.moveDialog = null;
            if(proceed === true) {

              Router.push(url);
            }
          },
          onLogged: function(logged) {
            console.log("logged on " + logged);
            this.$data.authorised = logged;
            if(logged == false) {
              this.onLogoutConfirmed();
              unsubscribeFCMTopic("");
            } else {
              getUserByToken();
            }
          },
          logout: function () {
            let self = this;
            this.$modal.show('dialog', {
                //title: '로그아웃',
                text: '로그아웃 하시겠습니까?',
                buttons: [
                    {
                        title: '아니요',
                        handler: () => {
                            self.$modal.hide('dialog');

                        }
                    },
                    {
                        title: '로그아웃',
                        handler: () => {
                            self.$modal.hide('dialog');
                            self.onLogoutConfirmed();
                        }
                    },

                ]

            });
          },
          onLogoutConfirmed: function () {
            localStorage.removeItem("JSTOKEN");
            localStorage.removeItem("email");
            localStorage.removeItem("id");
            this.$data.authorised = false;
            Router.push('/');
          },
          onSessionExpired: function() {
            this.$data.authorised = false;
            Router.push('/');
          },
          showLoading: function(show) {
            console.log("show loading " + show);
            this.$data.isLoading = show;
          },
          showDialog: function(params) {
            this.dialog = true
            this.dialogParams = params
            // this.$modal.show('dialog', params);
          },
          showBasket: function() {
            this.$data.basketView = true;
          },
          closeBasket: function() {
            this.$data.basketView = false;
          },
          checkNotice: function() {
            this.getNoticeList();
          },
          getNewNoticeCount: function() {
            let count = 0;
            if(this.$data.notices !== null && this.$data.notices.length > 0) {
              for(let i = 0 ; i < this.$data.notices.length ; i++) {
                if(this.$data.notices[i].readTime === 0) {
                  count+=1;
                }
              }
            }
            return count;
          },
          showNoticeListView: function() {
            this.$data.noticeListView = true;
            this.getNoticeList();
          },
          getNoticeList: function() {
            let self = this;
            getNotices()
            .then(function(data) {
              if(data.success == true) {
                self.$data.notices = data.item;
              } else {

              }
            })
            .catch(function(err) {

            })
          },


          openNoticeItem: function(notice) {
            this.$data.noticeItem = notice;
          },
          markAsRead: function() {
            if(this.$data.noticeItem !== false) {
              let self = this;
              setNoticeAsRead(this.$data.noticeItem.id)
              .then(function(data) {
                if(data.success === true) {
                  self.$data.noticeItem = false;
                  for(let i = 0 ; i < self.$data.notices.length ; i++) {
                    if(self.$data.notices[i].id === data.item.id) {
                      self.$data.notices.splice(i, 1, data.item);
                      return;
                    }
                  }
                }
              })
              .catch(function(err) {

              })
            }
          },
          onUserType: function(type) {
              this.$data.userType = type;
          },
          onBasket: function(add) {
            this.basket = getBasketOrderCount();
          },
        }
    }
</script>
<style scoped>
.loader-container {
  width: 100%;
  height: 100%;
  top:0;
  left: 0;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
}
.lds-circle {
  display: inline-block;
  transform: translateZ(1px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.lds-circle > div {
  display: inline-block;
  width: 120px;
  height: 120px;
  margin: 20px;
  border-radius: 50%;
  background: #fff;
  animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
@keyframes lds-circle {
  0%, 100% {
    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
  }
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(1800deg);
    animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
  }
  100% {
    transform: rotateY(3600deg);
  }
}

</style>
<!--<style lang="css" scoped>-->
<!--  .nav-container {-->
<!--    /*background: #333;*/-->
<!--    /*margin-bottom: 20px;*/-->
<!--    height: 50px;-->
<!--    background-image: linear-gradient(#969797, black);-->
<!--    position: relative;-->
<!--  }-->
<!--  ul {-->
<!--    display: flex;-->
<!--    list-style-type: none;-->
<!--    margin: auto;-->
<!--    position: absolute;-->
<!--    bottom: 0;-->
<!--    left:50%;-->
<!--    transform: translateX(-50%);-->
<!--    padding: 0;-->
<!--    overflow: hidden;-->
<!--    background-color: transparent;-->
<!--  }-->

<!--  li {-->
<!--    float: left;-->
<!--  }-->

<!--  li a {-->
<!--    display: block;-->
<!--    color: white;-->
<!--    text-align: center;-->
<!--    /*padding: 14px 16px;*/-->
<!--    line-height: 50px;-->
<!--    height: 50px;-->
<!--    font-size: 25px;-->
<!--    text-decoration: none;-->
<!--    min-width: 100px;-->
<!--  }-->
<!--  @media only screen and (max-width: 380px) {-->
<!--    li a {-->
<!--      min-width: 100px;-->
<!--    }-->
<!--  }-->
<!--  /* Change the link color to #111 (black) on hover */-->

<!--  li a:hover:not(.active) {-->
<!--    text-decoration: none;-->
<!--    background-color: #fff000;-->
<!--    color: black;-->
<!--  }-->
<!--  .active {-->
<!--    background-color: #4CAF50;-->
<!--  }-->
<!--  .logo-container {-->
<!--    position: absolute;-->
<!--    top:10px;-->
<!--    left:50px;-->
<!--  }-->
<!--  .logout-btn {-->
<!--    color:white;-->
<!--    font-size:25px;-->
<!--    line-height: 52px;-->
<!--    padding-left: 20px;-->
<!--    padding-right: 20px;-->
<!--  }-->
<!--  .router-link:hover {-->

<!--  }-->
<!--  .router-link-active {-->
<!--    background-color: #fff000;-->
<!--    border-color: #fff000;-->
<!--    color: black;-->
<!--  }-->
<!--  .nav-container .logo {-->
<!--    width:100px;-->
<!--    height: 150px;-->
<!--    position: absolute;-->
<!--    left: 0;-->
<!--    top: 0;-->
<!--    background-image: url("/static/mace_logo.png");-->
<!--    background-position: left;-->
<!--    background-repeat: no-repeat;-->
<!--    background-size: 100px 100px;-->
<!--  }-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/TopNav.vue